/**
 * Keeps the bearer credential for the life of the browser tab: in memory through `Credentials`, and in
 * `sessionStorage` so a reload does not sign the account out. It never uses cookies or `localStorage`, so the
 * credential is not shared with other tabs, other origins or a parent domain.
 */
export class Vault {
	static readonly #key = 'beyond.cdn.bearer';
	#storage: Pick<Storage, 'getItem' | 'setItem' | 'removeItem'> | undefined;

	constructor(storage?: Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>) {
		this.#storage = storage;
	}

	read(): string | undefined {
		try {
			return this.#storage?.getItem(Vault.#key) ?? undefined;
		} catch {
			return undefined;
		}
	}

	write(token: string) {
		try {
			this.#storage?.setItem(Vault.#key, token);
		} catch {
			// Without storage the session lasts until the next reload
		}
	}

	clear() {
		try {
			this.#storage?.removeItem(Vault.#key);
		} catch {
			// Nothing to clear
		}
	}
}
